const postMessageHelper = (type, data) => {
  window?.parent?.postMessage(
    {data, type}, 'https://www.shopmannythings.com'
  )
}

export default postMessageHelper